import { render, staticRenderFns } from "./AdminRegionManage.vue?vue&type=template&id=f624361a&"
import script from "./AdminRegionManage.vue?vue&type=script&lang=js&"
export * from "./AdminRegionManage.vue?vue&type=script&lang=js&"
import style0 from "./AdminRegionManage.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports